import { TPatientVariable, TVariable } from './variable'
import { TLabel } from './locales'

export type TFormVariables = {
  id: number
  isRequired: boolean
  position: number
  VariableId: number
  Variable: TVariable
  FormId: number
  Form: TForm
}

export type TForm = {
  id: number
  intlLabel?: TLabel
  description?: string
  expiryPeriod?: number
  type: EFormType
  FormVariables: TFormVariables[]
  Variables: TVariable[]
}

export enum EFormType {
  QUALITY_OF_LIFE = 'QUALITY_OF_LIFE',
  VISUAL_ACUITY = 'VISUAL_ACUITY',
  CONTRAST_PERCEPTION = 'CONTRAST_PERCEPTION',
  AMSLER_GRID = 'AMSLER_GRID',
  MORISKY = 'MORISKY',
  MEDICAL_HISTORY = 'MEDICAL_HISTORY',
  CONSENT = 'CONSENT',
  QUALITY_OF_LIFE_NEI = 'QUALITY_OF_LIFE_NEI',
  MORISKY8 = 'MORISKY8',
  CUSTOM_FORM = 'CUSTOM_FORM',
  GOOD_TO_KNOW = 'GOOD_TO_KNOW',
  QUALITY_OF_LIFE_HORUS = 'QUALITY_OF_LIFE_HORUS',
  DROPS_COMFORT_HORUS = 'DROPS_COMFORT_HORUS',
  SATISFACTION = 'SATISFACTION',
}

export enum EPatientFormSender {
  COPILOT = 'COPILOT',
  CHATBOT = 'CHATBOT',
  WORKFLOW = 'WORKFLOW',
  USER = 'USER',
  PATIENT = 'PATIENT',
}
export enum EPatientFormStatus {
  UNSTARTED = 'UNSTARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  CLOSED = 'CLOSED',
}

export type TPatientForm = {
  id: number
  sender: EPatientFormSender
  status: EPatientFormStatus
  value: string
  expireAt?: string | null
  FormId: number
  Form: TForm
  createdAt: string
  updatedAt: string
  PatientVariables: TPatientVariable[]
  PatientFollowupId?: number | null
  PatientMedEventId?: number | null
}
